import { useState, InputHTMLAttributes } from 'react'
import cx from 'classnames'

import './style.scss'

export const PasswordInput = ({
  className,
  ...props
}: InputHTMLAttributes<HTMLInputElement>) => {
  const [show, setShow] = useState(false)

  return (
    <div className="PasswordInput">
      <input
        {...props}
        className={cx('Input PasswordInput__input', className)}
        type={show ? 'text' : 'password'}
      />

      <div
        className={cx('PasswordInput__icon', {
          'PasswordInput__icon--hide': !show,
        })}
        onClick={() => setShow(!show)}
      />
    </div>
  )
}
